import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

// import selectors
import { getGallerySubmissionStatus } from 'js/store/gallery/Gallery.selectors';

// import actions
import { clearGallerySubmissionStatus } from 'js/store/gallery/Gallery.actions';

// import icons
import SvgCross from 'js/components/svg/Svg.cross';

const GallerySubmissionStatus = () => {
  const dispatch = useDispatch();
  const submissionStatus = useSelector((state) => {
    return getGallerySubmissionStatus(state);
  });

  const { status = false, message = 'An error occurred. Please try again.' } = submissionStatus || {};

  return (
    <div
      className="submission-overlay"
      style={{
        display: status ? 'flex' : 'none',
      }}
    >
      <div className="coloured-background" />
      <button
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          transformOrigin: 'left bottom',
          transform: 'translate(-15px, 15px)',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white',
          borderRadius: '50%',
          padding: '8px',
          boxShadow: '0 10px 8px 0 rgba(0, 0, 0, 0.25)',
          width: '10vw',
          height: '10vw',
          maxWidth: '78px',
          maxHeight: '78px',
          zIndex: 2,
        }}
        onClick={() => dispatch(clearGallerySubmissionStatus())}
      >
        <SvgCross />
      </button>
      <div className="message-container">
        <h2>{status === 'success' ? 'Submission Successful!' : 'Submission Failed'}</h2>
        <p>
          {message ||
            (status === 'success' ? 'Thank you for your submission!' : 'An error occurred. Please try again.')}
        </p>
      </div>
    </div>
  );
};

export default GallerySubmissionStatus;
